(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationTopicDeleteController',CommunicationTopicDeleteController);

    CommunicationTopicDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationTopic'];

    function CommunicationTopicDeleteController($uibModalInstance, entity, CommunicationTopic) {
        var vm = this;
        vm.communicationTopic = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CommunicationTopic.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
